<div class="card border-0 shadow-sm h-100">
    <div class="card-body">
        <div class="d-sm-flex justify-content-center align-items-center mb-4">
            <h4 class="mb-0 text-secondary">{{ title }}</h4>
        </div>
        <dx-chart [dataSource]="data" [zoomAndPan]="{ argumentAxis: 'pan' }" resolveLabelOverlapping="hide" (onPointClick)="onPointClick($event)">
            @if (isStacked) {
                <dxo-common-series-settings argumentField="date" type="stackedbar">
                    <dxo-label [visible]="true" [customizeText]="formatLabelText"></dxo-label>
                </dxo-common-series-settings>
                @for (s of series; track s.valueField) {
                    <dxi-series [valueField]="s.valueField" [name]="s.name" [color]="s.color"></dxi-series>
                }
            } @else {
                @for (s of series; track s.valueField) {
                    <dxi-series argumentField="date" [valueField]="s.valueField" type="bar" [name]="s.name" [color]="s.color">
                        <dxo-label [visible]="true" [customizeText]="formatLabelText"></dxo-label>
                    </dxi-series>
                }
            }
            <dxo-argument-axis type="continuous" argumentType="datetime"
                               [wholeRange]="wholeRange" [visualRange]="visualRange"
                               [tickInterval]="tickInterval">
                <dxo-label [visible]="true"></dxo-label>
                <dxo-grid [visible]="false"></dxo-grid>
                <dxo-tick [visible]="false"></dxo-tick>
            </dxo-argument-axis>
            <dxi-value-axis>
                @if (formatPercent) {
                    <dxo-label [customizeText]="formatPercentText"></dxo-label>
                } @else {
                    <dxo-label format="decimal"></dxo-label>
                }
                @if (targetValue !== null) {
                    <dxi-constant-line [value]="targetValue!" [color]="targetColor" [width]="2" dashStyle="dash">
                        <dxo-label [text]="targetLabel" [visible]="true"></dxo-label>
                    </dxi-constant-line>
                }
            </dxi-value-axis>
            <dxo-legend [visible]="isStacked" verticalAlignment="bottom" horizontalAlignment="center"></dxo-legend>
            <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
        </dx-chart>
    </div>
</div>
